import { render, staticRenderFns } from "./question-group.vue?vue&type=template&id=744a7401&scoped=true&"
import script from "./question-group.vue?vue&type=script&lang=js&"
export * from "./question-group.vue?vue&type=script&lang=js&"
import style0 from "./question-group.vue?vue&type=style&index=0&id=744a7401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a7401",
  null
  
)

export default component.exports